export default __webpack_public_path__ + "static/media/Inter-Medium.6dcbc9be.ttf";